/*
 * Product Tab Block - collection group tabs (2 levels)
 *
 * Level 1 : [data-group-tab]   -> collection group button
 * Level 2 : .list-product-tabs[data-group-tabs] -> the collection tab row of that group
 *
 * Clicking a group shows its own collection tab row and activates the first
 * collection tab of that row. The product panels themselves are still handled by
 * the theme (halo.clickedActiveProductTabs / halo.doAjaxProductTabs in theme.js).
 */
(function () {
  'use strict';

  var GROUP_BTN = '[data-group-tab]';
  var BLOCK = '[data-product-tab-block]';

  function activateManually(block, tabButton) {
    var panel = document.getElementById(
      (tabButton.getAttribute('data-target') || '').replace('#', '')
    );

    block.querySelectorAll('.list-product-tabs .tab-links').forEach(function (btn) {
      btn.classList.remove('active');
    });
    block.querySelectorAll('[data-product-tabcontent]').forEach(function (content) {
      content.classList.remove('active');
    });

    tabButton.classList.add('active');
    if (!panel) return;
    panel.classList.add('active');

    if (window.jQuery) {
      var slider = window.jQuery(panel).find('.slick-slider.slick-initialized');
      if (slider.length) slider.slick('refresh');
    }
  }

  function showGroup(block, groupId) {
    block.querySelectorAll(GROUP_BTN).forEach(function (btn) {
      var isCurrent = btn.getAttribute('data-group-tab') === groupId;
      btn.classList.toggle('active', isCurrent);
      btn.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
    });

    block.querySelectorAll('[data-group-tabs]').forEach(function (list) {
      list.classList.toggle('is-active', list.getAttribute('data-group-tabs') === groupId);
    });

    // each group can own its own banner set - swap it with the tab
    block.querySelectorAll('[data-group-banner]').forEach(function (set) {
      set.classList.toggle('is-active', set.getAttribute('data-group-banner') === groupId);
    });

    block.querySelectorAll('[data-group-tabs="' + groupId + '"].tabs-scroller').forEach(updateScroller);

    var activeList = block.querySelector('[data-group-tabs="' + groupId + '"]');
    if (!activeList) return;

    var target =
      activeList.querySelector('.tab-links.active') || activeList.querySelector('.tab-links');
    if (!target || target.classList.contains('active')) return;

    // theme.js marks the block with .tabs-bound once its tab click handler is
    // attached. Going through that handler matters now that only the active panel
    // is rendered server-side: it is what loads the panel being opened. Falling back
    // to .ajax-loaded keeps this working against an older cached theme.js.
    if (window.jQuery && (block.classList.contains('tabs-bound') || block.classList.contains('ajax-loaded'))) {
      window.jQuery(target).trigger('click');
    } else {
      activateManually(block, target);
    }
  }

  /* ---- collection tab row: arrows + overflow state ---- */

  function updateScroller(scroller) {
    var list = scroller.querySelector('.scroller__list');
    if (!list) return;

    var max = list.scrollWidth - list.clientWidth;
    var overflows = max > 4;
    var prev = scroller.querySelector('.tabs-scroller__btn--prev');
    var next = scroller.querySelector('.tabs-scroller__btn--next');

    scroller.classList.toggle('is-overflowing', overflows);
    if (prev) prev.hidden = !overflows || list.scrollLeft <= 2;
    if (next) next.hidden = !overflows || list.scrollLeft >= max - 2;
  }

  /* ---- product row: horizontal scroll arrows ---- */

  // One click = one full page of columns, so the row never stops on a half card
  function pageStep(row) {
    var card = row.querySelector('.product');
    if (!card) return Math.round(row.clientWidth);

    var styles = getComputedStyle(row);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    var column = card.getBoundingClientRect().width + gap;
    if (!column) return Math.round(row.clientWidth);

    var perPage = Math.max(1, Math.round((row.clientWidth + gap) / column));
    return Math.round(perPage * column);
  }

  function updateProductArrows(panel) {
    var list = panel.querySelector('.products-flex');
    var prev = panel.querySelector('.products-scroll__btn--prev');
    var next = panel.querySelector('.products-scroll__btn--next');
    if (!list || (!prev && !next)) return;

    var max = list.scrollWidth - list.clientWidth;
    var overflows = max > 4;
    if (prev) prev.hidden = !overflows || list.scrollLeft <= 2;
    if (next) next.hidden = !overflows || list.scrollLeft >= max - 2;
  }

  // Show the real banner box size in the empty-state placeholder, so the editor
  // tells you exactly what to export instead of a hardcoded guess.
  function updateBannerHints(scope) {
    scope.querySelectorAll('.product-block__banner .not_img').forEach(function (ph) {
      var figure = ph.closest('figure') || ph.parentElement;
      if (!figure) return;

      var w = Math.round(figure.offsetWidth);
      var h = Math.round(figure.offsetHeight);
      if (!w || !h) return;

      var label = ph.querySelector('.placeholder-desktop') || ph;
      var text = w + ' x ' + h + 'px';
      if (label.textContent !== text) label.textContent = text;
    });
  }

  function updateAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.tabs-scroller').forEach(updateScroller);
    scope.querySelectorAll('[data-product-tabcontent]').forEach(updateProductArrows);
    // product-block sections keep the arrows next to the row instead of in a tab panel
    scope.querySelectorAll('.halo-block-content').forEach(updateProductArrows);
    updateBannerHints(scope);
  }

  // AJAX fills the product row after the tab is clicked - re-check the arrows then
  function watchProductRows() {
    document.querySelectorAll(BLOCK + ', .halo-product-block').forEach(function (block) {
      if (block.dataset.arrowWatch) return;
      if (!block.querySelector('.products-scroll__btn')) return;
      block.dataset.arrowWatch = '1';

      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { updateAll(block); }, 200);
      }).observe(block, { childList: true, subtree: true });
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var scrollBtn = event.target.closest('[data-tab-scroll]');
    if (scrollBtn) {
      var scroller = scrollBtn.closest('.tabs-scroller');
      var list = scroller && scroller.querySelector('.scroller__list');
      if (!list) return;
      event.preventDefault();
      list.scrollBy({
        left: Math.round(list.clientWidth * 0.8) * Number(scrollBtn.getAttribute('data-tab-scroll')),
        behavior: 'smooth'
      });
      return;
    }

    var productBtn = event.target.closest('[data-product-scroll]');
    if (productBtn) {
      var panel = productBtn.closest('[data-product-tabcontent]') || productBtn.parentElement;
      var row = panel && panel.querySelector('.products-flex');
      if (!row) return;
      event.preventDefault();
      row.scrollBy({
        left: pageStep(row) * Number(productBtn.getAttribute('data-product-scroll')),
        behavior: 'smooth'
      });
      return;
    }

    var trigger = event.target.closest(GROUP_BTN);
    if (!trigger) return;

    var block = trigger.closest(BLOCK);
    if (!block) return;

    event.preventDefault();
    showGroup(block, trigger.getAttribute('data-group-tab'));
    requestAnimationFrame(function () { updateAll(block); });
  });

  // scroll does not bubble - listen in the capture phase
  document.addEventListener('scroll', function (event) {
    var list = event.target;
    if (!list.classList) return;

    if (list.classList.contains('products-flex')) {
      var panel = list.closest('[data-product-tabcontent]');
      if (panel) updateProductArrows(panel);
      return;
    }

    if (!list.classList.contains('scroller__list')) return;
    var scroller = list.closest('.tabs-scroller');
    if (scroller) updateScroller(scroller);
  }, true);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { updateAll(); }, 150);
  });

  function boot() {
    watchProductRows();
    updateAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);

  // Theme editor: make sure the first group is the visible one after a re-render.
  document.addEventListener('shopify:section:load', function (event) {
    var block = event.target.querySelector(BLOCK);
    if (!block) return;

    var firstGroup = block.querySelector(GROUP_BTN);
    if (firstGroup) showGroup(block, firstGroup.getAttribute('data-group-tab'));
    watchProductRows();
    updateAll(block);
  });
})();
